import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IReport } from '../../interface/IReport'
import ReportLine from './ReportLine'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import React from 'react'
import { IUser } from '../../interface/IUser'

const ReportLines = (props: any) => {
    const { expandAll, hasTimeCard } = props as { expandAll: boolean; hasTimeCard: boolean }
    const { t } = useTranslation()
    const report: IReport[] = useSelector((state: any) => state.report?.value)
    const user: IUser = useSelector((state: any) => state.user?.value)
    const theme = useTheme()
    const onCallUser: boolean = user?.worker?.mserp_mbrecordoncallduty || false

    return (
        <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow sx={{ backgroundColor: theme.palette.background.default }}>
                        <TableCell sx={{ padding: 1 }} />
                        <TableCell sx={{ padding: 1 }}>{t('report.date')}</TableCell>
                        {hasTimeCard && (
                            <>
                                <TableCell sx={{ padding: 1 }}>{t('report.from')}</TableCell>
                                <TableCell sx={{ padding: 1 }}>{t('report.to')}</TableCell>
                                <TableCell sx={{ padding: 1 }}>{t('report.break')}</TableCell>
                                <TableCell sx={{ padding: 1 }}>{t('report.traveltime')}</TableCell>
                                <TableCell sx={{ padding: 1 }}>{t('report.workingtimeAccordingArbZG')}</TableCell>
                                <TableCell sx={{ padding: 1 }}>{t('report.capacity')}</TableCell>
                                <TableCell sx={{ padding: 1 }}>{t('report.totalamount')}</TableCell>
                            </>
                        )}
                        {!hasTimeCard && <TableCell sx={{ padding: 1 }}>{t('report.fak_totalamount')}</TableCell>}
                        {onCallUser && <TableCell sx={{ padding: 1 }}>{t('zdeheader.oncall')}</TableCell>}
                        <TableCell sx={{ padding: 1 }}>{t('report.state')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {report.map((row: any, i: number) => (
                        <ReportLine row={row} key={i} id={i} expandAll={expandAll} hasTimeCard={hasTimeCard} onCallUser={onCallUser} />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default ReportLines
